import React from "react";
import { Show, SimpleShowLayout, TextField, ReferenceField } from "react-admin";

/**
 * PendantShow Component
 * @param {Object} props - The props passed to the component
 */
const PendantShow = (props) => {
  return (
    <Show {...props} title="Pendant">
      <SimpleShowLayout>
        <TextField source="name" label="Name" />
        <TextField source="uid" label="UID" />
        <TextField source="type" label="Type" />
        <ReferenceField
          label="Organization"
          source="org_id"
          reference="organizations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
      </SimpleShowLayout>
    </Show>
  );
};

export default PendantShow;
